// Static site data — single source of truth for DVP DIGI WORLD

export const company = {
  name: "DVP DIGI WORLD",
  tagline: "Your Unified Financial Partner",
  address:
    "No.10 Venkateswara Nagar, Perambur Paper Mills Road, Kolathur, Chennai – 600099.",
  phone: "9092622438",
  phoneAlt: "044 46231412",
  phoneHref: "tel:+919092622438",
  phoneAltHref: "tel:+914446231412",
  email: "contact@dvpdigiworld.com",
  mapsQuery:
    "No.10 Venkateswara Nagar, Perambur Paper Mills Road, Kolathur, Chennai 600099",
};

export const founders = [
  {
    id: "f1",
    name: "Vinoth Kumar B S",
    role: "Managing Partner",
    bio: "Over 18 years in financial services with American Express, Standard Chartered and Corporate DSA. Specialises in Housing Loans and LAP with successful disbursements exceeding ₹150 crores, plus ₹70 cr in layout projects and ₹60 cr in project financing. Focus: reliable, transparent, customer-centric financial solutions.",
    image:
      "https://customer-assets.emergentagent.com/job_unified-finance-13/artifacts/eyn1xod3_photo1.jpeg",
  },
  {
    id: "f2",
    name: "Dhayalan D",
    role: "Partner",
    bio: "30+ years of extensive experience in the real estate industry. Successfully developed multiple own projects and actively involved in 30+ joint venture developments. Strong expertise in land development and building construction — plays a key role in project execution, partnerships and timely, quality delivery.",
    image:
      "https://customer-assets.emergentagent.com/job_unified-finance-13/artifacts/4rp0gvzq_photo2.jpeg",
  },
];

export const leadership = [
  {
    id: "l1",
    name: "Parthiban D",
    role: "General Manager",
    bio: "16+ years in administration and finance. Manages operations, financial planning and smooth day-to-day business functions. Strong organisational skills and a practical approach that supports efficient decision-making and business growth.",
    image:
      "https://customer-assets.emergentagent.com/job_unified-finance-13/artifacts/p24x33o7_photo3.jpeg",
  },
  {
    id: "l2",
    name: "Gowri M",
    role: "Accounts & Finance Manager",
    bio: "18+ years in accounts and finance. Responsible for financial operations, compliance and maintaining accurate records. Expertise in financial controls, reporting and risk management ensures stability and long-term growth.",
    image:
      "https://customer-assets.emergentagent.com/job_unified-finance-13/artifacts/cblzyg7o_photo4.jpeg",
  },
  {
    id: "l3",
    name: "Renugadevi R",
    role: "Management Team",
    bio: "7+ years in business operations and team coordination. Supports daily activities, ensures smooth workflow and maintains effective communication across teams — contributing to efficient operations and overall business performance.",
    image:
      "https://customer-assets.emergentagent.com/job_unified-finance-13/artifacts/7v1lg5es_photo5.jpeg",
  },
  {
    id: "l4",
    name: "Vignesh K.T",
    role: "Loan & Finance Expert",
    bio: "6+ years in financial services. Specialises in loan processes, client coordination and providing suitable financial solutions based on customer needs. Strong understanding of loan products with a customer-focused approach.",
    image:
      "https://customer-assets.emergentagent.com/job_unified-finance-13/artifacts/ygjzfrbb_photo6.jpeg",
  },
  {
    id: "l5",
    name: "Preethi T",
    role: "Trusted Financial Advisor",
    bio: "11+ years in financial services. Guides clients with the right financial solutions including loans, insurance and investment options. Focus on trust, transparency and customer satisfaction to help clients build long-term financial stability.",
    image:
      "https://customer-assets.emergentagent.com/job_unified-finance-13/artifacts/l5p89t0s_photo7.jpeg",
  },
];

export const services = [
  {
    slug: "personal-loans",
    title: "Personal Loans",
    short:
      "Unsecured funding for life's milestones — weddings, travel, renovations and more.",
    long:
      "Access competitive personal loan products from our network of leading banks and NBFCs. Quick decisioning, transparent pricing and dependable support from application through disbursal.",
    icon: "Wallet",
  },
  {
    slug: "business-loans",
    title: "Business Loans",
    short:
      "Working capital and term loans tailored to SMEs and growing enterprises.",
    long:
      "Structured business funding for operational needs, expansion, and capex requirements. Our team helps you present a clean application to suitable lenders for faster approvals.",
    icon: "Briefcase",
  },
  {
    slug: "mortgage-loans",
    title: "Mortgage Loans (LAP)",
    short:
      "Loan against property for individuals and businesses with transparent terms.",
    long:
      "Unlock the value of your property with competitive LAP offerings. Led by a team with ₹150+ crores in housing and LAP disbursements, we manage documentation, lender liaison and end-to-end processing with clarity at every stage.",
    icon: "Building2",
  },
  {
    slug: "home-loans",
    title: "Home Loans",
    short:
      "Funding your home with partner banks offering the most relevant rates.",
    long:
      "From first-time homebuyers to balance transfers, access the right home loan from a curated network of institutional partners with smoother processing and quicker response times.",
    icon: "Home",
  },
  {
    slug: "doctor-professional-loans",
    title: "Doctor & Professional Loans",
    short:
      "Dedicated funding solutions for doctors and qualified professionals.",
    long:
      "Specialised loan products for doctors, chartered accountants, lawyers and other qualified professionals — for clinic set-up, equipment, working capital and personal requirements at preferential terms.",
    icon: "Stethoscope",
  },
  {
    slug: "insurance",
    title: "Insurance Solutions",
    short:
      "Life, health, vehicle and general insurance to protect what matters most.",
    long:
      "Comprehensive protection plans for individuals and businesses — life, health, motor, vehicle and general insurance through partnerships with leading insurers. Claims support and timely renewal reminders included.",
    icon: "ShieldCheck",
  },
  {
    slug: "investments",
    title: "Mutual Funds & SIPs",
    short:
      "Goal-based investing through mutual funds and Systematic Investment Plans.",
    long:
      "Structured wealth-building with curated mutual fund and SIP recommendations aligned to your goals, risk profile and time horizon — backed by 11+ years of advisory experience on our team.",
    icon: "TrendingUp",
  },
  {
    slug: "sme-corporate",
    title: "SME & Corporate Solutions",
    short:
      "Custom financial support for SMEs and corporate clients — capital, credit and ops.",
    long:
      "Structured capital support, credit and operational resources for SMEs and corporates. End to end compliant, audit ready and delivered within predefined turnaround times.",
    icon: "LineChart",
  },
];

export const additionalServices = [
  {
    title: "Loan Closure Support",
    desc: "End-to-end assistance on pre-closure, foreclosure charges and NOC tracking.",
    icon: "FileCheck2",
  },
  {
    title: "Balance Transfer",
    desc: "Move existing loans to better rates with smoother processing and minimal paperwork.",
    icon: "ArrowLeftRight",
  },
  {
    title: "Plan Approvals",
    desc: "Building plan approvals and regulatory follow-ups for smooth project execution.",
    icon: "FileSignature",
  },
  {
    title: "Patta Processing",
    desc: "Patta applications, transfers and follow-ups handled end-to-end.",
    icon: "ScrollText",
  },
  {
    title: "Surveyor Working Diagrams",
    desc: "Working diagrams and site drawings prepared through qualified surveyors.",
    icon: "Compass",
  },
  {
    title: "Document Registration",
    desc: "Sub-registrar liaison and registration assistance for seamless paperwork.",
    icon: "BadgeCheck",
  },
];

export const whyChoose = [
  {
    title: "Experienced Founding Team",
    desc: "Deep domain knowledge across banking, housing finance, LAP, real estate and operations.",
  },
  {
    title: "Five-Member Leadership",
    desc: "A seasoned leadership team supported by a young, dynamic execution workforce.",
  },
  {
    title: "Trusted Lender Network",
    desc: "Access to leading banks, NBFCs and institutional partners across products.",
  },
  {
    title: "End-to-End Support",
    desc: "From enquiry and documentation to approval and disbursal — one trusted partner.",
  },
  {
    title: "Audit-Ready Process",
    desc: "Transparent, compliant and audit-ready orientation inspired by modern fintech.",
  },
  {
    title: "Quick Decisioning",
    desc: "Decisioned and disbursed within predefined turnaround times.",
  },
];

// logo.dev — free public token, falls back to text on failure
const LOGO_TOKEN = "pk_X-1ZO13GSgeOoUrIuJ6GMQ";
const logoUrl = (domain) =>
  `https://img.logo.dev/${domain}?token=${LOGO_TOKEN}&format=png&size=200`;

export const partners = [
  { name: "HDFC Bank", logo: logoUrl("hdfcbank.com") },
  { name: "ICICI Bank", logo: logoUrl("icicibank.com") },
  { name: "Axis Bank", logo: logoUrl("axisbank.com") },
  { name: "State Bank of India", logo: logoUrl("onlinesbi.sbi") },
  { name: "Kotak Mahindra Bank", logo: logoUrl("kotak.com") },
  { name: "Bajaj Finance", logo: logoUrl("bajajfinserv.in") },
  { name: "Tata Capital", logo: logoUrl("tatacapital.com") },
  { name: "L&T Finance", logo: logoUrl("ltfs.com") },
  { name: "IndusInd Bank", logo: logoUrl("indusind.com") },
  { name: "Yes Bank", logo: logoUrl("yesbank.in") },
  { name: "Federal Bank", logo: logoUrl("federalbank.co.in") },
  { name: "IIFL Finance", logo: logoUrl("iifl.com") },
];

export const stats = [
  { value: 150, suffix: "Cr+", label: "Loan disbursed" },
  { value: 1000, suffix: "+", label: "Happy customers" },
  { value: 20, suffix: "+", label: "Cities covered" },
  { value: 100, suffix: "%", label: "Audit-ready processes" },
];

export const customerTypes = ["Individual", "Business", "SME", "Corporate"];

export const productOptions = [
  "Personal Loan",
  "Business Loan",
  "Mortgage Loan (LAP)",
  "Home Loan",
  "Doctor / Professional Loan",
  "Insurance",
  "Mutual Funds / SIP",
  "Other",
];
